var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserGear = function SvgUserGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M9 9.855a4.25 4.25 0 1 0-4.494 0c-1.29.422-2.452 1.212-3.385 2.323a.5.5 0 1 0 .765.644C3.14 11.324 4.869 10.5 6.75 10.5s3.61.824 4.867 2.322a.5.5 0 0 0 .766-.644c-.934-1.111-2.095-1.9-3.383-2.323M3.5 6.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m12.266 2.692-.292-.168c.035-.181.035-.367 0-.548l.292-.168a.5.5 0 0 0-.5-.866l-.292.169q-.212-.181-.474-.275V6.75a.5.5 0 0 0-1 0v.336a1.5 1.5 0 0 0-.474.275l-.292-.17a.5.5 0 1 0-.5.867l.292.168c-.034.181-.034.367 0 .548l-.292.168a.501.501 0 0 0 .5.866l.292-.169q.212.181.474.275v.336a.5.5 0 1 0 1 0v-.336q.262-.094.474-.275l.292.17a.495.495 0 0 0 .554-.037.5.5 0 0 0-.054-.83M13.5 8.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
  })));
};
export default SvgUserGear;